<div class="smart-grid">
  <div class="smart-grid_wrapper" *ngIf="gridOptions">
    <ag-grid-angular
      style="width: 100%"
      [ngStyle]="{
        height: height ? height : (gridOptions.rowData?.length ? '100%' : 'auto')
      }"
      class="ag-theme-alpine-smart-table smart-grid_table"
      [gridOptions]="gridOptions"
    >
    </ag-grid-angular>
  </div>
</div>
